// extracted by mini-css-extract-plugin
export default {"data":"LisencePlate_data__5BBD7"};